// extracted by mini-css-extract-plugin
module.exports = {"card":"card__E+KQH","cardHeader":"cardHeader__o8zxI","cardHeaderBorder":"cardHeaderBorder__hikXI","cardPairing":"cardPairing__+PFsO","cardLoader":"cardLoader__E6iNb"};